import React from 'react'

export default function RevinuLogo({ className, size = 22, ...props }) {
    return (
        <svg
            className={className}
            width={size}
            height={size}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <text
                x="50%"
                y="54%"
                dominantBaseline="middle"
                textAnchor="middle"
                fill="currentColor"
                fontFamily="Inter, sans-serif"
                fontWeight="800"
                fontSize="22"
            >
                R
            </text>
            <rect x="2" y="2" width="36" height="36" rx="8" stroke="currentColor" strokeWidth="2.5" fill="none" />
        </svg>
    )
}
